import React, { Suspense, useState, useEffect, useMemo } from "react";
import { useParams } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import "./cardView.css";
import InputRange from "react-input-range";
import { FaEyeSlash, FaEye } from "react-icons/fa";
import Nodes from "../../Helpers/nodesList.js";
import PerfectScrollbar from "react-perfect-scrollbar";
import { Col, FormGroup, Input } from "reactstrap";
import { Link } from "react-router-dom";
import Loading from "../../components/Loading";
import LoggedHeader from "../../DefaultLayout/LoggedHeader";
import Footer from "../../DefaultLayout/Footer";
import DashboardNavbar from "../../DefaultLayout/DashboardNavbar.js";
import CardContent from "./CardContent";
import TableData from "../sample/TableData";
import "react-input-range/lib/css/index.css";
import "./slider.css";
import CheckboxTree from "react-checkbox-tree";
import { toIsNumberFormat } from "../../Helpers/numbers";
import "./checkbox.scss";

import {
  MdCheckBox,
  MdCheckBoxOutlineBlank,
  MdChevronRight,
  MdKeyboardArrowDown,
  MdAddBox,
  MdIndeterminateCheckBox,
  MdAdd,
  MdRemove,
} from "react-icons/md";
import Header from "../../DefaultLayout/Header";
import { getPropertyList } from "../../actions/propertyAction";
import { connect, useSelector } from "react-redux";
import { Redirect, useHistory } from "react-router-dom";
import swal from "sweetalert";
import { runningSubscription } from "../../actions/subscription";
import { dropdownPropertyField } from "../../actions/propertyFieldAction";
// import { roomOptions } from "../../constant/rooms.js";
import { frontLabel } from "../../Helpers/labels.js";

const icons = {
  check: (
    <MdCheckBox
      className="rct-icon rct-icon-check"
      sx={{ color: "#000!important" }}
    />
  ),
  uncheck: <MdCheckBoxOutlineBlank className="rct-icon rct-icon-uncheck" />,
  halfCheck: (
    <MdIndeterminateCheckBox className="rct-icon rct-icon-half-check" />
  ),
  expandClose: <MdChevronRight className="rct-icon rct-icon-expand-close" />,
  expandOpen: <MdKeyboardArrowDown className="rct-icon rct-icon-expand-open" />,
  expandAll: <MdAddBox className="rct-icon rct-icon-expand-all" />,
  collapseAll: (
    <MdIndeterminateCheckBox className="rct-icon rct-icon-collapse-all" />
  ),
  parentClose: <MdAdd className="rct-icon rct-icon-parent-close" />,
  parentOpen: <MdRemove className="rct-icon rct-icon-parent-open" />,
  // leaf: <MdInsertDriveFile className="rct-icon rct-icon-leaf-close" />
};

function CardView(props) {
  const {
    direction,
    getPropertyList,
    properties,
    label,
    dropdownPropertyField,
    ...args
  } = props;
  const propertyData = properties;
  const lng = localStorage.getItem("prevLangFront");
  const { frontLabelsName } = label;
  const nodes = Nodes();
  const params = useParams();
  const history = useHistory();
  const [allProperty, setAllProperty] = useState([]);
  const [inhabitants, setInhabitants] = useState("");
  const [gender, setGender] = useState("");
  const [smoking, setSmoking] = useState("");
  const [pets, setPets] = useState("");

  const [openZip, setOpenZip] = useState(false);
  const [propPriceVal, setPropPriceVal] = useState({
    min: 0,
    max: 1000000,
  });
  const [propSizeVal, setPropSizeVal] = useState({ min: 0, max: 2000 });
  const [open, setOpen] = useState(true);
  const [open1, setOpen1] = useState(false);
  const [checkbox, setCheckbox] = useState({
    Furniture: false,
    withElevator: false,
    Garage: false,
    storage: false,
    bathroomBath: false,
    privateEntrance: false,
    withCharging: false,
    laundryFacilitiesInTheBasement: false,
    withWheelchair: false,
    withBalcony: false,
    Pets: false,
  });

  const [tableOpen, setTableOpen] = useState(false);
  const [allData, setAllData] = useState(true);
  const [menuOpen, setMenuOpen] = useState(true);

  const [checkedTree, setCheckedTree] = useState(["0"]);
  const [expandedTree, setExpandedTree] = useState(["0"]);
  const [filterText, setFilterText] = useState("");
  const [search, setSearch] = useState(
    args.location.state ? args.location.state : "",
  );

  const [nodesFiltered, setNodesFiltered] = useState();
  const [clickedTree, setClickedTree] = useState([]);

  const [newToday, setNewToday] = useState(false);
  const [newThisWeek, setNewThisWeek] = useState(false);
  const [room, setRoom] = useState([]);
  const [rentalPeriod, setRentalPeriod] = useState("");
  const [propertyType, setPropertyType] = useState("");
  const [page, setPage] = useState(1);
  const [filterLoading, setFilterLoading] = useState(false);
  const [navType, setNavType] = useState("");
  const [enterSearch, setEnterSearch] = useState("");
  const [propert, setPropert] = useState(true);
  const [priceData, setPriceData] = useState("");
  const [sizeData, setSizeData] = useState("");

  const [openNav1, setOpenNav1] = useState(false);

  const [homeApplianceType, setHomeApplianceType] = useState([]);
  const [restrictionsType, setRestrictionsType] = useState([]);
  const [accessType, setAccessType] = useState([]);
  const [otherType, setOtherType] = useState([]);
  const [checkedPropertyFieldTree, setCheckedPropertyFieldTree] = useState([
    "0",
  ]);
  const [expandedPropertyFieldTree, setExpandedPropertyFieldTree] = useState([
    "0",
  ]);
  const [filterPropertyFieldText, setFilterPropertyFieldText] = useState("");
  useState();
  const [clickedPropertyFieldTree, setClickedPropertyFieldTree] = useState([]);

  const [propertyLoad, setPropertyLoad] = useState(true);
  const [propertyTotal, setTotalProperty] = useState("");
  const [allDataLoaded, setAllDataLoaded] = useState(false);
  const tempIncluded = Object.keys(checkbox).map((val) => {
    if (checkbox[val] === true) {
      return val;
    } else {
      return false;
    }
  });

  const subscriptions = useSelector((state) => state.subscription);
  const subscription_details = subscriptions?.runningSubscription?.message;
  const ArrayChangeHandler = (arr) => {
    arr.forEach((object) => {
      object.value = object._id;
    });
    const newArrayOfHomeAppliance =
      arr?.length > 0 &&
      arr.map(({ _id: id, name, ...rest }) => {
        let label = Array.isArray(name)
          ? name?.filter((e) => e[lng])[0][lng]["name"]
          : name;
        return {
          id,
          label,
          ...rest,
        };
      });

    return newArrayOfHomeAppliance;
  };

  useEffect(() => {
    if (open1) {
      var elem = document.getElementById("scrolled");
      elem.scrollTop = elem.scrollHeight;
    }
  }, [open1]);

  useEffect(() => {
    dropdownPropertyField("").then((res) => {
      setHomeApplianceType(ArrayChangeHandler(res?.type_2));
      setRestrictionsType(ArrayChangeHandler(res?.type_3));
      setAccessType(ArrayChangeHandler(res?.type4));
      setOtherType(ArrayChangeHandler(res?.type5));
    });
  }, [lng]);

  useEffect(() => {
    if (params.key === "room" && params.value) {
      setRoom([params.value]);
    }
    if (params.key === "property-type" && params.value) {
      setPropertyType(params.value);
    }
  }, [params]);

  useEffect(() => {
    if (params.key === "room" && params.value && room.length === 0) return;
    if (params.key === "property-type" && params.value && !propertyType) return;

    setFilterLoading(true);
    // if (page === 1) window.scrollTo(0, 0);

    getPropertyList(
      page,
      12,
      search,
      JSON.stringify(room),
      filterText,
      rentalPeriod,
      propertyType,
      propSizeVal.min,
      propSizeVal.max,
      propPriceVal.min,
      propPriceVal.max,
      newToday ? "1" : newThisWeek ? "2" : "",
      // included.toString(),
      filterPropertyFieldText.toString(),
      navType,
      smoking,
      pets,
      gender,
      inhabitants,
    ).then((res) => {
      setFilterLoading(false);
      setPropertyLoad(false);
      setTotalProperty(res.totalDocs);
      setAllDataLoaded(res?.hasNextPage === false ? true : false);
      setAllProperty(page === 1 ? res?.docs : [...allProperty, ...res?.docs]);
    });
  }, [
    page,
    navType,
    enterSearch,
    room,
    filterText,
    rentalPeriod,
    propertyType,
    sizeData,
    priceData,
    newToday,
    newThisWeek,
    checkbox,
    filterPropertyFieldText,
    smoking,
    pets,
    gender,
    inhabitants,
    params,
  ]);

  const isAuth = useSelector((state) => state.auth.isAuthenticated);

  useEffect(() => {
    if (isAuth.isAuthenticated) {
      const userId = localStorage.getItem("user");
      props.runningSubscription(userId);
    }
  }, []);

  const propertyFieldNodes = [
    {
      id: 3001,
      value: "3001",
      label: frontLabelsName
        ? frontLabelsName.filter((e) => e.key == "lbl_home_appliances").length >
          0
          ? frontLabelsName.filter((e) => e.key == "lbl_home_appliances")[0][
              "value"
            ] || "lbl_home_appliances"
          : "lbl_home_appliances"
        : "lbl_home_appliances",
      children: homeApplianceType,
    },
    {
      id: 3002,
      value: "3002",
      label: frontLabelsName
        ? frontLabelsName.filter((e) => e.key == "lbl_restrictions").length > 0
          ? frontLabelsName.filter((e) => e.key == "lbl_restrictions")[0][
              "value"
            ] || "lbl_restrictions"
          : "lbl_restrictions"
        : "lbl_restrictions",
      children: restrictionsType,
    },
    {
      id: 3003,
      value: "3003",
      label: frontLabelsName
        ? frontLabelsName.filter((e) => e.key == "lbl_access").length > 0
          ? frontLabelsName.filter((e) => e.key == "lbl_access")[0]["value"] ||
            "lbl_access"
          : "lbl_access"
        : "lbl_access",
      children: accessType,
    },
    {
      id: 3004,
      value: "3004",
      label: frontLabelsName
        ? frontLabelsName.filter((e) => e.key == "lbl_other").length > 0
          ? frontLabelsName.filter((e) => e.key == "lbl_other")[0]["value"] ||
            "lbl_other"
          : "lbl_other"
        : "lbl_other",
      children: otherType,
    },
  ];

  const filterPropertyFieldNodes = (filtered, node) => {
    const children = (node.children || []).reduce(filterPropertyFieldNodes, []);
    if (
      // Node's label matches the search string
      node.label
        .toLocaleLowerCase()
        .indexOf(filterPropertyFieldText.toLocaleLowerCase()) > -1 ||
      // Or a children has a matching node
      children.length
    ) {
      filtered.push({ ...node, ...(children.length && { children }) });
    }
    return filtered;
  };

  const handlePropertyField = () => {
    setOpen1(!open1);
  };

  const handlePageChange = (p) => {
    setPage(p);
  };

  const filterTree = () => {
    // Reset nodes back to unfiltered state
    if (!filterText || filterText === "" || filterText.length === 0) {
      setNodesFiltered(nodes);
      return;
    }

    const nodesFiltered = (nodes) => {
      return nodes.reduce(filterNodes, []);
    };

    setNodesFiltered(nodesFiltered);
  };

  const filterNodes = (filtered, node) => {
    const children = (node.children || []).reduce(filterNodes, []);
    if (
      // Node's label matches the search string
      node.label.toLocaleLowerCase().indexOf(filterText.toLocaleLowerCase()) >
        -1 ||
      // Or a children has a matching node
      children.length
    ) {
      filtered.push({ ...node, ...(children.length && { children }) });
    }
    return filtered;
  };
  //

  const handleHideButton = () => {
    setOpen(!open);
  };

  const handleClose = () => {
    setOpen1(!open1);
  };

  const handleTableData = () => {
    setTableOpen(true);
    setAllData(false);
  };
  const handleAllData = () => {
    setAllData(true);
    setTableOpen(false);
  };

  const [isMobile, setIsMobile] = useState(window.innerWidth < 1200);

  useEffect(() => {
    window.addEventListener(
      "resize",
      () => {
        const ismobile = window.innerWidth < 992;
        if (ismobile !== isMobile) setIsMobile(ismobile);
      },
      false,
    );
  }, [isMobile]);

  const handleZipCode = () => {
    filterTree();
    setOpenZip(!openZip);
  };

  const handleEnter = (e) => {
    if (e.target.name === "search") {
      if (e.key === "Enter") {
        setPage(1);
        setEnterSearch(e.target.value);
      }
    }
  };

  const onResetFilter = () => {
    window.scrollTo(0, 0);
    args.location.state = "";
    setFilterLoading(true);
    setOpenNav1(false);
    setSearch("");
    setRoom([]);
    setFilterText("");
    setRentalPeriod("");
    setNewThisWeek(false);
    setNewToday(false);
    setPropPriceVal({ min: 100, max: 2000000 });
    setPropSizeVal({ min: 0, max: 1000000000 });
    setCheckbox({
      Furniture: false,
      withElevator: false,
      Garage: false,
      storage: false,
      bathroomBath: false,
      privateEntrance: false,
      withCharging: false,
      laundryFacilitiesInTheBasement: false,
      withWheelchair: false,
      withBalcony: false,
      Pets: false,
    });
    setPropertyType("");
    setPage(1);
    setOpen1(false);
    setCheckedTree(["0"]);
    setExpandedTree(["0"]);
    setOpenZip(false);
    setNavType("");
    setFilterPropertyFieldText("");
    setExpandedPropertyFieldTree(["0"]);
    setCheckedPropertyFieldTree(["0"]);
    setSmoking("");
    setInhabitants("");
    setGender("");
    setPets("");
    setEnterSearch("");
    history.push("/properties");
  };

  const onNavSearch = (navSearch) => {
    setFilterLoading(true);
    getPropertyList(
      1,
      12,
      navSearch,
      JSON.stringify(room),
      filterText,
      rentalPeriod,
      propertyType,
      propSizeVal.min,
      propSizeVal.max,
      propPriceVal.min,
      propPriceVal.max,
      newToday ? "1" : newThisWeek ? "2" : "",
      filterPropertyFieldText.toString(),
      navType,
      smoking,
      pets,
      gender,
      inhabitants,
    ).then((res) => {
      setFilterLoading(false);
      setAllProperty(res?.docs);
    });
  };

  if (isAuth == false) {
    swal({
      title: frontLabelsName
        ? frontLabelsName.filter((e) => e.key == "lbl_please_login").length > 0
          ? frontLabelsName.filter((e) => e.key == "lbl_please_login")[0][
              "value"
            ] || "lbl_please_login"
          : "lbl_please_login"
        : "lbl_please_login",
      text: frontLabelsName
        ? frontLabelsName.filter((e) => e.key == "lbl_login_view_properties")
            .length > 0
          ? frontLabelsName.filter(
              (e) => e.key == "lbl_login_view_properties",
            )[0]["value"] || "lbl_login_view_properties"
          : "lbl_login_view_properties"
        : "lbl_login_view_properties",
      icon: "info",
      buttons: [
        null,
        frontLabelsName
          ? frontLabelsName.filter((e) => e.key == "lbl_continue").length > 0
            ? frontLabelsName.filter((e) => e.key == "lbl_continue")[0][
                "value"
              ] || "lbl_continue"
            : "lbl_continue"
          : "lbl_continue",
      ],
      dangerMode: true,
    }).then((willDelete) => {
      if (willDelete) {
      }
    });
    return <Redirect to={"/login"} />;
  }

  // if (subscription_status == 0) {
  if (subscription_details !== "Your subscription is active.") {
    swal({
      title: frontLabelsName
        ? frontLabelsName.filter((e) => e.key == "lbl_purchage_subscribe")
            .length > 0
          ? frontLabelsName.filter((e) => e.key == "lbl_purchage_subscribe")[0][
              "value"
            ] || "lbl_purchage_subscribe"
          : "lbl_purchage_subscribe"
        : "lbl_purchage_subscribe",
      text: frontLabelsName
        ? frontLabelsName.filter((e) => e.key == "lbl_subscribe_to_view")
            .length > 0
          ? frontLabelsName.filter((e) => e.key == "lbl_subscribe_to_view")[0][
              "value"
            ] || "lbl_subscribe_to_view"
          : "lbl_subscribe_to_view"
        : "lbl_subscribe_to_view",
      icon: "info",
      buttons: [
        null,
        frontLabelsName
          ? frontLabelsName.filter((e) => e.key == "lbl_continue").length > 0
            ? frontLabelsName.filter((e) => e.key == "lbl_continue")[0][
                "value"
              ] || "lbl_continue"
            : "lbl_continue"
          : "lbl_continue",
      ],
      dangerMode: true,
    }).then((willDelete) => {
      if (willDelete) {
      }
    });
    return <Redirect to={"/subscription"} />;
  }

  const getIncludedName = (val) => {
    if (val === "Stove Four burner") {
      return frontLabelsName
        ? frontLabelsName.filter((e) => e.key == "lbl_stove_four_burner")
            .length > 0
          ? frontLabelsName.filter((e) => e.key == "lbl_stove_four_burner")[0][
              "value"
            ] || "lbl_stove_four_burner"
          : "lbl_stove_four_burner"
        : "lbl_stove_four_burner";
    } else if (val === "Television") {
      return frontLabelsName
        ? frontLabelsName.filter((e) => e.key == "lbl_television").length > 0
          ? frontLabelsName.filter((e) => e.key == "lbl_television")[0][
              "value"
            ] || "lbl_television"
          : "lbl_television"
        : "lbl_television";
    } else if (val === "Dishwasher") {
      return frontLabelsName
        ? frontLabelsName.filter((e) => e.key == "lbl_dishwasher").length > 0
          ? frontLabelsName.filter((e) => e.key == "lbl_dishwasher")[0][
              "value"
            ] || "lbl_dishwasher"
          : "lbl_dishwasher"
        : "lbl_dishwasher";
    } else if (val === "Garage") {
      return frontLabelsName
        ? frontLabelsName.filter((e) => e.key == "lbl_garage").length > 0
          ? frontLabelsName.filter((e) => e.key == "lbl_garage")[0]["value"] ||
            "lbl_garage"
          : "lbl_garage"
        : "lbl_garage";
    } else if (val === "With Balcony") {
      return frontLabelsName
        ? frontLabelsName.filter((e) => e.key == "lbl_television").length > 0
          ? frontLabelsName.filter((e) => e.key == "lbl_television")[0][
              "value"
            ] || "lbl_television"
          : "lbl_television"
        : "lbl_television";
    } else if (val === "With Balcony") {
      return frontLabelsName
        ? frontLabelsName.filter((e) => e.key == "lbl_with_balcony").length > 0
          ? frontLabelsName.filter((e) => e.key == "lbl_with_balcony")[0][
              "value"
            ] || "lbl_with_balcony"
          : "lbl_with_balcony"
        : "lbl_with_balcony";
    } else if (val === "Storage") {
      return frontLabelsName
        ? frontLabelsName.filter((e) => e.key == "lbl_storage").length > 0
          ? frontLabelsName.filter((e) => e.key == "lbl_storage")[0]["value"] ||
            "lbl_storage"
          : "lbl_storage"
        : "lbl_storage";
    } else if (val === "Elevator") {
      return frontLabelsName
        ? frontLabelsName.filter((e) => e.key == "lbl_elevator").length > 0
          ? frontLabelsName.filter((e) => e.key == "lbl_elevator")[0][
              "value"
            ] || "lbl_elevator"
          : "lbl_elevator"
        : "lbl_elevator";
    } else if (val === "Laundry Facilities in the basement") {
      return frontLabelsName
        ? frontLabelsName.filter((e) => e.key == "lbl_laundry_facilities")
            .length > 0
          ? frontLabelsName.filter((e) => e.key == "lbl_laundry_facilities")[0][
              "value"
            ] || "lbl_laundry_facilities"
          : "lbl_laundry_facilities"
        : "lbl_laundry_facilities";
    } else if (val === "Private entrance") {
      return frontLabelsName
        ? frontLabelsName.filter((e) => e.key == "lbl_private_entrance")
            .length > 0
          ? frontLabelsName.filter((e) => e.key == "lbl_private_entrance")[0][
              "value"
            ] || "lbl_private_entrance"
          : "lbl_private_entrance"
        : "lbl_private_entrance";
    } else if (val === "Bathroom bath") {
      return frontLabelsName
        ? frontLabelsName.filter((e) => e.key == "lbl_bathroom_bath").length > 0
          ? frontLabelsName.filter((e) => e.key == "lbl_bathroom_bath")[0][
              "value"
            ] || "lbl_bathroom_bath"
          : "lbl_bathroom_bath"
        : "lbl_bathroom_bath";
    } else if (val === "Furniture") {
      return frontLabelsName
        ? frontLabelsName.filter((e) => e.key == "lbl_furniture").length > 0
          ? frontLabelsName.filter((e) => e.key == "lbl_furniture")[0][
              "value"
            ] || "lbl_furniture"
          : "lbl_furniture"
        : "lbl_furniture";
    }
  };

  var zipcustom;
  if (checkedTree && checkedTree[0] == "0") {
    zipcustom = "";
  } else if (
    checkedTree &&
    checkedTree[0] != "0" &&
    checkedTree?.toString()?.length <= 16
  ) {
    zipcustom = checkedTree?.toString();
  } else if (
    checkedTree &&
    checkedTree[0] != "0" &&
    checkedTree?.toString()?.length > 16
  ) {
    zipcustom = checkedTree?.toString().substring(0, 16) + "...";
  }

  // const searchRoomOptions = roomOptions(frontLabelsName);

  const valueToSlider = (price, target75 = 1000000) => {
    if (price <= target75) {
      return (price / target75) * 75;
    } else {
      return 75 + ((price - target75) / target75) * 25;
    }
  };

  return (
    <React.Fragment>
      <Suspense fallback={<Loading />}>
        {isAuth ? <LoggedHeader /> : <Header />}
        <DashboardNavbar
          propertVal={propert}
          setType={setNavType}
          onNavSearch={onNavSearch}
          type={navType}
          setSearch1={setSearch}
          search1={search}
          openNav1={openNav1}
          setOpenNav1={setOpenNav1}
          setPage={setPage}
          setRoom={setRoom}
          setPropertyType={setPropertyType}
        />
      </Suspense>
      <div className="Container mb-5 main-box">
        <div className="row">
          {open ? (
            <div className="col-lg-3 col-md-12 d-flex ">
              <div className="div-styles22 card-content-div-sticky">
                <PerfectScrollbar
                  style={{
                    height: isMobile ? "auto" : "100%",
                    maxHeight: isMobile ? "auto" : "90vh",
                    overflowX: "hidden",
                    width: "auto",
                  }}
                  id="scrolled"
                >
                  <div style={{ width: "93%" }}>
                    <div className="btn-filter leftbar-fiter ">
                      <button className="hide-btn" onClick={handleHideButton}>
                        <FaEyeSlash className="sets-gap-btn" />
                        <span>
                          {frontLabelsName
                            ? frontLabelsName.filter(
                                (e) => e.key == "lbl_hide_filter",
                              ).length > 0
                              ? frontLabelsName.filter(
                                  (e) => e.key == "lbl_hide_filter",
                                )[0]["value"] || "lbl_hide_filter"
                              : "lbl_hide_filter"
                            : "lbl_hide_filter"}
                        </span>
                      </button>
                      <button className="reset-btn" onClick={onResetFilter}>
                        {frontLabelsName
                          ? frontLabelsName.filter((e) => e.key == "lbl_reset")
                              .length > 0
                            ? frontLabelsName.filter(
                                (e) => e.key == "lbl_reset",
                              )[0]["value"] || "lbl_reset"
                            : "lbl_reset"
                          : "lbl_reset"}
                      </button>
                    </div>
                    <div
                      className={`${isMobile ? "leftbar-fiter1" : "leftbar-fiter"}`}
                    >
                      <div className="d-flex filter-btn-three  padding-style">
                        <Link to="#" onClick={handleAllData}>
                          {allData ? (
                            <img
                              src="assets/card.svg"
                              alt="Group 13522"
                              className="icon-shadows1"
                            />
                          ) : (
                            <img
                              src="assets/card-active.svg"
                              alt="Group 13522"
                            />
                          )}
                        </Link>
                        <Link to="/properties-list" onClick={handleTableData}>
                          {tableOpen ? (
                            <img
                              src="assets/list-active.svg"
                              alt="Group 13521"
                              className="icon-shadows1"
                            />
                          ) : (
                            <img src="assets/list.svg" alt="Group 13521" />
                          )}
                        </Link>
                        <Link to="/map-view">
                          <img src="assets/map.svg" alt="Group 13521" />
                        </Link>
                      </div>

                      <div className="new padding-style">
                        <form className="d-flex new1 gap-3 flex-wrap">
                          <div className="form-group">
                            <input
                              type="checkbox"
                              id="New today"
                              checked={newToday}
                              onChange={(e) => {
                                setPage(1);
                                setNewToday(!newToday);
                              }}
                            />
                            <label htmlFor="New today">
                              {frontLabelsName
                                ? frontLabelsName.filter(
                                    (e) => e.key == "lbl_new_today",
                                  ).length > 0
                                  ? frontLabelsName.filter(
                                      (e) => e.key == "lbl_new_today",
                                    )[0]["value"] || "lbl_new_today"
                                  : "lbl_new_today"
                                : "lbl_new_today"}
                            </label>
                          </div>
                          <div className="form-group ">
                            <input
                              type="checkbox"
                              id="New this week"
                              checked={newThisWeek}
                              onChange={(e) => {
                                setPage(1);
                                setNewThisWeek(!newThisWeek);
                              }}
                            />
                            <label htmlFor="New this week">
                              {frontLabelsName
                                ? frontLabelsName.filter(
                                    (e) => e.key == "lbl_new_week",
                                  ).length > 0
                                  ? frontLabelsName.filter(
                                      (e) => e.key == "lbl_new_week",
                                    )[0]["value"] || "lbl_new_week"
                                  : "lbl_new_week"
                                : "lbl_new_week"}
                            </label>
                          </div>
                        </form>
                      </div>
                      <FormGroup className="set-bg-feild pt-2">
                        <Col sm={12} style={{ position: "relative" }}>
                          <Input
                            type="text"
                            name="Enter Zip Code"
                            placeholder={
                              frontLabelsName
                                ? frontLabelsName.filter(
                                    (e) => e.key == "lbl_enter_zipcode",
                                  ).length > 0
                                  ? frontLabelsName.filter(
                                      (e) => e.key == "lbl_enter_zipcode",
                                    )[0]["value"] || "lbl_enter_zipcode"
                                  : "lbl_enter_zipcode"
                                : "lbl_enter_zipcode"
                            }
                            className="set-bg-input"
                            autoComplete="off"
                            onClick={handleZipCode}
                            value={zipcustom}
                            // style={{ color: "transparent" }}
                            // onChange={onFilterChange}
                          />
                          {openZip && (
                            <div className="zipcode-style">
                              <PerfectScrollbar
                                style={{
                                  maxHeight: "300px",
                                  overflowX: "hidden",

                                  width: "100%",
                                }}
                              >
                                <CheckboxTree
                                  nodes={nodes}
                                  checked={checkedTree}
                                  expanded={expandedTree}
                                  expandOnClick={true}
                                  onClick={(clickedTree) =>
                                    setClickedTree(clickedTree)
                                  }
                                  onCheck={(checkedTree) => {
                                    setPage(1);
                                    setCheckedTree(checkedTree);
                                    setFilterText(checkedTree.toString());
                                  }}
                                  onExpand={(expandedTree) =>
                                    setExpandedTree(expandedTree)
                                  }
                                  icons={icons}
                                  // nativeCheckboxes={true}
                                />
                              </PerfectScrollbar>
                            </div>
                          )}
                        </Col>
                      </FormGroup>

                      <div></div>
                      {menuOpen && (
                        <div>
                          <FormGroup row className="set-bg-feild pt-2">
                            <Col sm={12}>
                              <select
                                name="select"
                                id="exampleSelect"
                                className={`set-bg-input ${!propertyType ? "has-placeholder" : ""}`}
                                style={{ width: "100%" }}
                                value={propertyType}
                                onChange={(e) => {
                                  setPage(1);
                                  setPropertyType(e.target.value);
                                }}
                              >
                                <option value={""}>
                                  {frontLabelsName
                                    ? frontLabelsName.filter(
                                        (e) =>
                                          e.key == "lbl_select_property_type",
                                      ).length > 0
                                      ? frontLabelsName.filter(
                                          (e) =>
                                            e.key == "lbl_select_property_type",
                                        )[0]["value"] ||
                                        "lbl_select_property_type"
                                      : "lbl_select_property_type"
                                    : "lbl_select_property_type"}
                                </option>
                                <option value={"detachedHouse"}>
                                  {frontLabelsName
                                    ? frontLabelsName.filter(
                                        (e) => e.key == "lbl_detached_house",
                                      ).length > 0
                                      ? frontLabelsName.filter(
                                          (e) => e.key == "lbl_detached_house",
                                        )[0]["value"] || "lbl_detached_house"
                                      : "lbl_detached_house"
                                    : "lbl_detached_house"}
                                </option>
                                <option value={"duplex"}>
                                  {frontLabelsName
                                    ? frontLabelsName.filter(
                                        (e) => e.key == "lbl_duplex",
                                      ).length > 0
                                      ? frontLabelsName.filter(
                                          (e) => e.key == "lbl_duplex",
                                        )[0]["value"] || "lbl_duplex"
                                      : "lbl_duplex"
                                    : "lbl_duplex"}
                                </option>
                                <option value={"tripleAptHouse"}>
                                  {frontLabelsName
                                    ? frontLabelsName.filter(
                                        (e) => e.key == "lbl_triple_apt_house",
                                      ).length > 0
                                      ? frontLabelsName.filter(
                                          (e) =>
                                            e.key == "lbl_triple_apt_house",
                                        )[0]["value"] || "lbl_triple_apt_house"
                                      : "lbl_triple_apt_house"
                                    : "lbl_triple_apt_house"}
                                </option>
                                <option value={"aptBulding"}>
                                  {frontLabelsName
                                    ? frontLabelsName.filter(
                                        (e) => e.key == "lbl_apt_building",
                                      ).length > 0
                                      ? frontLabelsName.filter(
                                          (e) => e.key == "lbl_apt_building",
                                        )[0]["value"] || "lbl_apt_building"
                                      : "lbl_apt_building"
                                    : "lbl_apt_building"}
                                </option>
                                <option value={"townhouseTwin"}>
                                  {frontLabelsName
                                    ? frontLabelsName.filter(
                                        (e) => e.key == "lbl_townhouse_twin",
                                      ).length > 0
                                      ? frontLabelsName.filter(
                                          (e) => e.key == "lbl_townhouse_twin",
                                        )[0]["value"] || "lbl_townhouse_twin"
                                      : "lbl_townhouse_twin"
                                    : "lbl_townhouse_twin"}
                                </option>
                                <option value={"garage"}>
                                  {frontLabelsName
                                    ? frontLabelsName.filter(
                                        (e) => e.key == "lbl_garage",
                                      ).length > 0
                                      ? frontLabelsName.filter(
                                          (e) => e.key == "lbl_garage",
                                        )[0]["value"] || "lbl_garage"
                                      : "lbl_garage"
                                    : "lbl_garage"}
                                </option>
                                <option value={"summerHouse"}>
                                  {frontLabelsName
                                    ? frontLabelsName.filter(
                                        (e) => e.key == "lbl_summer_house",
                                      ).length > 0
                                      ? frontLabelsName.filter(
                                          (e) => e.key == "lbl_summer_house",
                                        )[0]["value"] || "lbl_summer_house"
                                      : "lbl_summer_house"
                                    : "lbl_summer_house"}
                                </option>
                                <option value={"cotenant"}>
                                  {frontLabelsName
                                    ? frontLabelsName.filter(
                                        (e) => e.key == "lbl_co_tenant",
                                      ).length > 0
                                      ? frontLabelsName.filter(
                                          (e) => e.key == "lbl_co_tenant",
                                        )[0]["value"] || "lbl_co_tenant"
                                      : "lbl_co_tenant"
                                    : "lbl_co_tenant"}
                                </option>
                                <option value={"hotelGesthouse"}>
                                  {frontLabelsName
                                    ? frontLabelsName.filter(
                                        (e) => e.key == "lbl_hotel_guest_house",
                                      ).length > 0
                                      ? frontLabelsName.filter(
                                          (e) =>
                                            e.key == "lbl_hotel_guest_house",
                                        )[0]["value"] || "lbl_hotel_guest_house"
                                      : "lbl_hotel_guest_house"
                                    : "lbl_hotel_guest_house"}
                                </option>
                              </select>
                            </Col>
                          </FormGroup>
                          <FormGroup row className="set-bg-feild pt-2">
                            <Col sm={12} style={{ position: "relative" }}>
                              <Input
                                type="text"
                                placeholder={
                                  frontLabelsName
                                    ? frontLabelsName.filter(
                                        (e) =>
                                          e.key == "lbl_search_street_name",
                                      ).length > 0
                                      ? frontLabelsName.filter(
                                          (e) =>
                                            e.key == "lbl_search_street_name",
                                        )[0]["value"] ||
                                        "lbl_search_street_name"
                                      : "lbl_search_street_name"
                                    : "lbl_search_street_name"
                                }
                                className="set-bg-input search-text-padding"
                                value={search}
                                name="search"
                                onChange={(e) => {
                                  // setPage(1)
                                  setSearch(e.target.value);
                                }}
                                onKeyPress={handleEnter}
                              />
                              <i className="fa fa-search search-icon-style" />
                            </Col>
                          </FormGroup>

                          <div className="Property_room-main padding-style">
                            <h2>
                              {frontLabelsName
                                ? frontLabelsName.filter(
                                    (e) =>
                                      e.key == "lbl_search_for_multiple_room",
                                  ).length > 0
                                  ? frontLabelsName.filter(
                                      (e) =>
                                        e.key == "lbl_search_for_multiple_room",
                                    )[0]["value"] ||
                                    "lbl_search_for_multiple_room"
                                  : "lbl_search_for_multiple_room"
                                : "lbl_search_for_multiple_room"}
                            </h2>
                            <div className="set-btn-no">
                              <h6>
                                {frontLabelsName
                                  ? frontLabelsName.filter(
                                      (e) => e.key == "lbl_bedroom",
                                    ).length > 0
                                    ? frontLabelsName.filter(
                                        (e) => e.key == "lbl_bedroom",
                                      )[0]["value"] || "lbl_bedroom"
                                    : "lbl_bedroom"
                                  : "lbl_bedroom"}
                              </h6>
                              <div className="link-btn-sets  col-12">
                                <div
                                  className="set-bg-btn-no"
                                  onClick={() => {
                                    if (room.includes("Storage")) {
                                      setPage(1);
                                      const filterVal = room.filter(
                                        (val) => val !== "Storage",
                                      );

                                      setRoom(filterVal);
                                    } else {
                                      setPage(1);
                                      setRoom([...room, "Storage"]);
                                    }
                                  }}
                                >
                                  <span
                                    className={
                                      room.includes("Storage")
                                        ? "set-bg-btn-no-5"
                                        : "set-bg-btn-no-6"
                                    }
                                  >
                                    {frontLabelsName
                                      ? frontLabelsName.filter(
                                          (e) => e.key == "lbl_storage",
                                        ).length > 0
                                        ? frontLabelsName.filter(
                                            (e) => e.key == "lbl_storage",
                                          )[0]["value"] || "lbl_storage"
                                        : "lbl_storage"
                                      : "lbl_storage"}
                                  </span>
                                </div>
                                <div
                                  className="set-bg-btn-no"
                                  onClick={() => {
                                    if (room.includes("Single Room")) {
                                      setPage(1);
                                      const filterVal = room.filter(
                                        (val) => val !== "Single Room",
                                      );

                                      setRoom(filterVal);
                                    } else {
                                      setPage(1);
                                      setRoom([...room, "Single Room"]);
                                    }
                                  }}
                                >
                                  <span
                                    className={
                                      room.includes("Single Room")
                                        ? "set-bg-btn-no-5"
                                        : "set-bg-btn-no-6"
                                    }
                                  >
                                    {frontLabelsName
                                      ? frontLabelsName.filter(
                                          (e) => e.key == "lbl_single_room",
                                        ).length > 0
                                        ? frontLabelsName.filter(
                                            (e) => e.key == "lbl_single_room",
                                          )[0]["value"] || "lbl_single_room"
                                        : "lbl_single_room"
                                      : "lbl_single_room"}
                                  </span>
                                </div>
                                <div
                                  className="set-bg-btn-no"
                                  onClick={() => {
                                    if (room.includes("Studio")) {
                                      setPage(1);
                                      const filterVal = room.filter(
                                        (val) => val !== "Studio",
                                      );

                                      setRoom(filterVal);
                                    } else {
                                      setPage(1);
                                      setRoom([...room, "Studio"]);
                                    }
                                  }}
                                >
                                  <span
                                    className={
                                      room.includes("Studio")
                                        ? "set-bg-btn-no-5"
                                        : "set-bg-btn-no-6"
                                    }
                                  >
                                    {frontLabelsName
                                      ? frontLabelsName.filter(
                                          (e) => e.key == "lbl_studio",
                                        ).length > 0
                                        ? frontLabelsName.filter(
                                            (e) => e.key == "lbl_studio",
                                          )[0]["value"] || "lbl_studio"
                                        : "lbl_studio"
                                      : "lbl_studio"}
                                  </span>
                                </div>
                                <div
                                  className="set-bg-btn-no"
                                  onClick={() => {
                                    if (room.includes("2")) {
                                      setPage(1);
                                      const filterVal = room.filter(
                                        (val) => val !== "2",
                                      );

                                      setRoom(filterVal);
                                    } else {
                                      setPage(1);
                                      setRoom([...room, "2"]);
                                    }
                                  }}
                                >
                                  <div
                                    className={
                                      room.includes("2")
                                        ? "set-bg-btn-no4"
                                        : "set-bg-btn-no3"
                                    }
                                  >
                                    2
                                  </div>
                                </div>
                                <div
                                  className="set-bg-btn-no"
                                  onClick={() => {
                                    if (room.includes("3")) {
                                      setPage(1);
                                      const filterVal = room.filter(
                                        (val) => val !== "3",
                                      );

                                      setRoom(filterVal);
                                    } else {
                                      setPage(1);
                                      setRoom([...room, "3"]);
                                    }
                                  }}
                                >
                                  <div
                                    className={
                                      room.includes("3")
                                        ? "set-bg-btn-no4"
                                        : "set-bg-btn-no3"
                                    }
                                  >
                                    3
                                  </div>
                                </div>
                                <div
                                  className="set-bg-btn-no"
                                  onClick={() => {
                                    if (room.includes("4")) {
                                      setPage(1);
                                      const filterVal = room.filter(
                                        (val) => val !== "4",
                                      );

                                      setRoom(filterVal);
                                    } else {
                                      setPage(1);
                                      setRoom([...room, "4"]);
                                    }
                                  }}
                                >
                                  <div
                                    className={
                                      room.includes("4")
                                        ? "set-bg-btn-no4"
                                        : "set-bg-btn-no3"
                                    }
                                  >
                                    4
                                  </div>
                                </div>
                                <div
                                  className="set-bg-btn-no"
                                  onClick={() => {
                                    if (room.includes("5")) {
                                      setPage(1);
                                      const filterVal = room.filter(
                                        (val) => val !== "5",
                                      );

                                      setRoom(filterVal);
                                    } else {
                                      setPage(1);
                                      setRoom([...room, "5"]);
                                    }
                                  }}
                                >
                                  <div
                                    className={
                                      room.includes("5")
                                        ? "set-bg-btn-no4"
                                        : "set-bg-btn-no3"
                                    }
                                  >
                                    5+
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="Rental padding-style">
                            <h2>
                              {frontLabelsName
                                ? frontLabelsName.filter(
                                    (e) => e.key == "lbl_rental_period",
                                  ).length > 0
                                  ? frontLabelsName.filter(
                                      (e) => e.key == "lbl_rental_period",
                                    )[0]["value"] || "lbl_rental_period"
                                  : "lbl_rental_period"
                                : "lbl_rental_period"}
                            </h2>
                            <div className="check-sets-availbe">
                              <div className="field-group1">
                                <label htmlFor="15">
                                  {frontLabelsName
                                    ? frontLabelsName.filter(
                                        (e) => e.key == "lbl_available_now",
                                      ).length > 0
                                      ? frontLabelsName.filter(
                                          (e) => e.key == "lbl_available_now",
                                        )[0]["value"] || "lbl_available_now"
                                      : "lbl_available_now"
                                    : "lbl_available_now"}
                                </label>
                                <input
                                  id="15"
                                  type="checkbox"
                                  value={rentalPeriod}
                                  onChange={() => {
                                    if (rentalPeriod !== "1") {
                                      setPage(1);
                                      setRentalPeriod("1");
                                    } else {
                                      setPage(1);
                                      setRentalPeriod("");
                                    }
                                  }}
                                  checked={rentalPeriod === "1"}
                                />
                              </div>

                              <div
                                className="field-group1"
                                style={{ border: "none" }}
                              >
                                <label htmlFor="17">
                                  {frontLabelsName
                                    ? frontLabelsName.filter(
                                        (e) => e.key == "lbl_long_term_rental",
                                      ).length > 0
                                      ? frontLabelsName.filter(
                                          (e) =>
                                            e.key == "lbl_long_term_rental",
                                        )[0]["value"] || "lbl_long_term_rental"
                                      : "lbl_long_term_rental"
                                    : "lbl_long_term_rental"}
                                </label>
                                <input
                                  id="17"
                                  type="checkbox"
                                  value={rentalPeriod}
                                  onChange={() => {
                                    if (rentalPeriod !== "3") {
                                      setPage(1);
                                      setRentalPeriod("3");
                                    } else {
                                      setPage(1);
                                      setRentalPeriod("");
                                    }
                                  }}
                                  checked={rentalPeriod === "3"}
                                />
                              </div>
                            </div>
                          </div>
                          <div className="Property_Price padding-style">
                            <h2>
                              {frontLabel(frontLabelsName, "lbl_price")}, Kr.
                            </h2>
                            <span className="set-val-price">
                              {propPriceVal.min} -{" "}
                              {toIsNumberFormat(propPriceVal.max)}+
                            </span>
                            <div>
                              <div className="pt-3 ms-2">
                                <InputRange
                                  step={5}
                                  formatLabel={(value) => null}
                                  draggableTrack={false}
                                  allowSameValues={false}
                                  maxValue={1000000}
                                  minValue={0}
                                  value={propPriceVal}
                                  onChange={setPropPriceVal}
                                  onChangeComplete={(args) => {
                                    setPage(1);
                                    setPriceData(args);
                                  }}
                                />
                              </div>
                            </div>
                          </div>

                          <div className="Property_Price padding-style">
                            <h2>
                              {frontLabel(frontLabelsName, "lbl_size")}, m
                              <sup>2</sup>
                            </h2>
                            <span className="set-val-price">
                              {propSizeVal.min} -{" "}
                              {toIsNumberFormat(propSizeVal.max)}+
                            </span>
                            <div>
                              <div className="pt-3 ms-2">
                                <InputRange
                                  step={5}
                                  formatLabel={(value) => null}
                                  draggableTrack={false}
                                  allowSameValues={false}
                                  maxValue={1000}
                                  minValue={0}
                                  value={propSizeVal}
                                  onChange={setPropSizeVal}
                                  onChangeComplete={(args) => {
                                    setPage(1);
                                    setSizeData(args);
                                  }}
                                />
                              </div>
                            </div>
                          </div>

                          <div
                            className="d-flex padding-style custom-dp"
                            style={{ display: "flex", flexDirection: "column" }}
                            onClose={handleClose}
                          >
                            <button
                              className="advace-btn"
                              onClose={handleClose}
                              onClick={handlePropertyField}
                              type="button"
                              style={{}}
                            >
                              {frontLabelsName
                                ? frontLabelsName.filter(
                                    (e) => e.key == "lbl_advanced",
                                  ).length > 0
                                  ? frontLabelsName.filter(
                                      (e) => e.key == "lbl_advanced",
                                    )[0]["value"] || "lbl_advanced"
                                  : "lbl_advanced"
                                : "lbl_advanced"}
                            </button>
                            {open1 && (
                              <div className="advanced-btn-content">
                                <div>
                                  <FormGroup row className="set-bg-feild">
                                    <Col sm={12}>
                                      <select
                                        name="select"
                                        id="inhabitants"
                                        className={`set-bg-input ${!inhabitants ? "has-placeholder" : ""}`}
                                        style={{ width: "100%" }}
                                        value={inhabitants}
                                        onChange={(e) => {
                                          setPage(1);
                                          setInhabitants(e.target.value);
                                        }}
                                      >
                                        <option value={""}>
                                          {frontLabelsName
                                            ? frontLabelsName.filter(
                                                (e) =>
                                                  e.key ==
                                                  "lbl_allowed_number_of_inhabitants",
                                              ).length > 0
                                              ? frontLabelsName.filter(
                                                  (e) =>
                                                    e.key ==
                                                    "lbl_allowed_number_of_inhabitants",
                                                )[0]["value"] ||
                                                "lbl_allowed_number_of_inhabitants"
                                              : "lbl_allowed_number_of_inhabitants"
                                            : "lbl_allowed_number_of_inhabitants"}
                                        </option>
                                        <option value={"agreement"}>
                                          {frontLabelsName
                                            ? frontLabelsName.filter(
                                                (e) => e.key == "lbl_agreement",
                                              ).length > 0
                                              ? frontLabelsName.filter(
                                                  (e) =>
                                                    e.key == "lbl_agreement",
                                                )[0]["value"] || "lbl_agreement"
                                              : "lbl_agreement"
                                            : "lbl_agreement"}
                                        </option>
                                        <option value={"1"}>1</option>
                                        <option value={"2"}>2</option>
                                        <option value={"3"}>3</option>
                                        <option value={"4"}>4</option>
                                        <option value={"5"}>5</option>
                                        <option value={"6"}>6</option>
                                        <option value={"7"}>7</option>
                                        <option value={"8"}>8</option>
                                        <option value={"9"}>9</option>
                                        <option value={"10"}>10</option>
                                      </select>
                                    </Col>
                                  </FormGroup>
                                  <FormGroup row className="set-bg-feild ">
                                    <Col sm={12}>
                                      <select
                                        name="select"
                                        id="gender"
                                        className={`set-bg-input ${!gender ? "has-placeholder" : ""}`}
                                        style={{ width: "100%" }}
                                        value={gender}
                                        onChange={(e) => {
                                          setPage(1);
                                          setGender(e.target.value);
                                        }}
                                      >
                                        <option value={""}>
                                          {frontLabelsName
                                            ? frontLabelsName.filter(
                                                (e) =>
                                                  e.key == "lbl_select_gender",
                                              ).length > 0
                                              ? frontLabelsName.filter(
                                                  (e) =>
                                                    e.key ==
                                                    "lbl_select_gender",
                                                )[0]["value"] ||
                                                "lbl_select_gender"
                                              : "lbl_select_gender"
                                            : "lbl_select_gender"}
                                        </option>
                                        <option value={0}>
                                          {frontLabelsName
                                            ? frontLabelsName.filter(
                                                (e) =>
                                                  e.key == "lbl_all_gender",
                                              ).length > 0
                                              ? frontLabelsName.filter(
                                                  (e) =>
                                                    e.key == "lbl_all_gender",
                                                )[0]["value"] ||
                                                "lbl_all_gender"
                                              : "lbl_all_gender"
                                            : "lbl_all_gender"}
                                        </option>
                                        <option value={1}>
                                          {" "}
                                          {frontLabelsName
                                            ? frontLabelsName.filter(
                                                (e) => e.key == "lbl_only_male",
                                              ).length > 0
                                              ? frontLabelsName.filter(
                                                  (e) =>
                                                    e.key == "lbl_only_male",
                                                )[0]["value"] || "lbl_only_male"
                                              : "lbl_only_male"
                                            : "lbl_only_male"}
                                        </option>
                                        <option value={2}>
                                          {" "}
                                          {frontLabelsName
                                            ? frontLabelsName.filter(
                                                (e) =>
                                                  e.key == "lbl_only_female",
                                              ).length > 0
                                              ? frontLabelsName.filter(
                                                  (e) =>
                                                    e.key == "lbl_only_female",
                                                )[0]["value"] ||
                                                "lbl_only_female"
                                              : "lbl_only_female"
                                            : "lbl_only_female"}
                                        </option>
                                        <option value={3}>
                                          {" "}
                                          {frontLabelsName
                                            ? frontLabelsName.filter(
                                                (e) => e.key == "lbl_other",
                                              ).length > 0
                                              ? frontLabelsName.filter(
                                                  (e) => e.key == "lbl_other",
                                                )[0]["value"] || "lbl_other"
                                              : "lbl_other"
                                            : "lbl_other"}
                                        </option>
                                        <option value={4}>
                                          {" "}
                                          {frontLabelsName
                                            ? frontLabelsName.filter(
                                                (e) => e.key == "lbl_couples",
                                              ).length > 0
                                              ? frontLabelsName.filter(
                                                  (e) => e.key == "lbl_couples",
                                                )[0]["value"] || "lbl_couples"
                                              : "lbl_couples"
                                            : "lbl_couples"}
                                        </option>
                                      </select>
                                    </Col>
                                  </FormGroup>
                                  <div className="set-btn-no">
                                    <h6 className="pt-0">
                                      {frontLabelsName
                                        ? frontLabelsName.filter(
                                            (e) => e.key == "lbl_smoking",
                                          ).length > 0
                                          ? frontLabelsName.filter(
                                              (e) => e.key == "lbl_smoking",
                                            )[0]["value"] || "lbl_smoking"
                                          : "lbl_smoking"
                                        : "lbl_smoking"}
                                    </h6>
                                    <div className="d-flex justify-content-between field-group-div">
                                      <div className="field-group10 d-flex align-items-center">
                                        <label htmlFor="smoking1">
                                          {frontLabelsName
                                            ? frontLabelsName.filter(
                                                (e) => e.key == "lbl_yes",
                                              ).length > 0
                                              ? frontLabelsName.filter(
                                                  (e) => e.key == "lbl_yes",
                                                )[0]["value"] || "lbl_yes"
                                              : "lbl_yes"
                                            : "lbl_yes"}
                                        </label>
                                        <input
                                          id="smoking1"
                                          type="checkbox"
                                          value={smoking}
                                          onChange={() => {
                                            if (smoking !== "1") {
                                              setPage(1);
                                              setSmoking("1");
                                            } else {
                                              setPage(1);
                                              setSmoking("");
                                            }
                                          }}
                                          checked={smoking === "1"}
                                          className="ms-1"
                                        />
                                      </div>
                                      <div className="field-group10 d-flex align-items-center">
                                        <label htmlFor="smoking2">
                                          {frontLabelsName
                                            ? frontLabelsName.filter(
                                                (e) => e.key == "lbl_no",
                                              ).length > 0
                                              ? frontLabelsName.filter(
                                                  (e) => e.key == "lbl_no",
                                                )[0]["value"] || "lbl_no"
                                              : "lbl_no"
                                            : "lbl_no"}
                                        </label>
                                        <input
                                          id="smoking2"
                                          type="checkbox"
                                          value={smoking}
                                          onChange={() => {
                                            if (smoking !== "2") {
                                              setPage(1);
                                              setSmoking("2");
                                            } else {
                                              setPage(1);
                                              setSmoking("");
                                            }
                                          }}
                                          checked={smoking === "2"}
                                          className="ms-1"
                                        />
                                      </div>
                                      <div className="field-group10 d-flex align-items-center">
                                        <label htmlFor="smoking3">
                                          {frontLabelsName
                                            ? frontLabelsName.filter(
                                                (e) => e.key == "lbl_agreement",
                                              ).length > 0
                                              ? frontLabelsName.filter(
                                                  (e) =>
                                                    e.key == "lbl_agreement",
                                                )[0]["value"] || "lbl_agreement"
                                              : "lbl_agreement"
                                            : "lbl_agreement"}
                                        </label>
                                        <input
                                          id="smoking3"
                                          type="checkbox"
                                          value={smoking}
                                          onChange={() => {
                                            if (smoking !== "3") {
                                              setPage(1);
                                              setSmoking("3");
                                            } else {
                                              setPage(1);
                                              setSmoking("");
                                            }
                                          }}
                                          checked={smoking === "3"}
                                          className="ms-1"
                                        />
                                      </div>
                                    </div>
                                  </div>
                                  <div className="set-btn-no pt-2">
                                    <h6>
                                      {frontLabelsName
                                        ? frontLabelsName.filter(
                                            (e) => e.key == "lbl_pets",
                                          ).length > 0
                                          ? frontLabelsName.filter(
                                              (e) => e.key == "lbl_pets",
                                            )[0]["value"] || "lbl_pets"
                                          : "lbl_pets"
                                        : "lbl_pets"}
                                    </h6>
                                    <div className="d-flex justify-content-between field-group-div">
                                      <div className="field-group10 d-flex align-items-center">
                                        <label htmlFor="pets1">
                                          {frontLabelsName
                                            ? frontLabelsName.filter(
                                                (e) => e.key == "lbl_yes",
                                              ).length > 0
                                              ? frontLabelsName.filter(
                                                  (e) => e.key == "lbl_yes",
                                                )[0]["value"] || "lbl_yes"
                                              : "lbl_yes"
                                            : "lbl_yes"}
                                        </label>
                                        <input
                                          id="pets1"
                                          type="checkbox"
                                          value={pets}
                                          onChange={() => {
                                            if (pets !== "1") {
                                              setPage(1);
                                              setPets("1");
                                            } else {
                                              setPage(1);
                                              setPets("");
                                            }
                                          }}
                                          checked={pets === "1"}
                                          className="ms-1"
                                        />
                                      </div>
                                      <div className="field-group10 d-flex align-items-center">
                                        <label htmlFor="pets2">
                                          {frontLabelsName
                                            ? frontLabelsName.filter(
                                                (e) => e.key == "lbl_no",
                                              ).length > 0
                                              ? frontLabelsName.filter(
                                                  (e) => e.key == "lbl_no",
                                                )[0]["value"] || "lbl_no"
                                              : "lbl_no"
                                            : "lbl_no"}
                                        </label>
                                        <input
                                          id="pets2"
                                          type="checkbox"
                                          value={pets}
                                          onChange={() => {
                                            if (pets !== "2") {
                                              setPage(1);
                                              setPets("2");
                                            } else {
                                              setPage(1);
                                              setPets("");
                                            }
                                          }}
                                          checked={pets === "2"}
                                          className="ms-1"
                                        />
                                      </div>
                                      <div className="field-group10 d-flex align-items-center">
                                        <label htmlFor="pets3">
                                          {frontLabelsName
                                            ? frontLabelsName.filter(
                                                (e) => e.key == "lbl_agreement",
                                              ).length > 0
                                              ? frontLabelsName.filter(
                                                  (e) =>
                                                    e.key == "lbl_agreement",
                                                )[0]["value"] || "lbl_agreement"
                                              : "lbl_agreement"
                                            : "lbl_agreement"}
                                        </label>
                                        <input
                                          id="pets3"
                                          type="checkbox"
                                          value={pets}
                                          onChange={() => {
                                            if (pets !== "3") {
                                              setPage(1);
                                              setPets("3");
                                            } else {
                                              setPage(1);
                                              setPets("");
                                            }
                                          }}
                                          checked={pets === "3"}
                                          className="ms-1"
                                        />
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <CheckboxTree
                                  nodes={propertyFieldNodes}
                                  checked={checkedPropertyFieldTree}
                                  expanded={expandedPropertyFieldTree}
                                  expandOnClick={true}
                                  onClick={(checkedPropertyFieldTree) =>
                                    setClickedPropertyFieldTree(
                                      checkedPropertyFieldTree,
                                    )
                                  }
                                  onCheck={(checkedPropertyFieldTree) => {
                                    setCheckedPropertyFieldTree(
                                      checkedPropertyFieldTree,
                                    );
                                    setFilterPropertyFieldText(
                                      checkedPropertyFieldTree.toString(),
                                    );
                                    setPage(1);
                                  }}
                                  onExpand={(expandedPropertyFieldTree) =>
                                    setExpandedPropertyFieldTree(
                                      expandedPropertyFieldTree,
                                    )
                                  }
                                  icons={icons}
                                  // nativeCheckboxes={true}
                                />
                                {/* {included1.length > 0 &&
                              included1.map((inc, i) => {
                                return (
                                  <div
                                    style={{ marginLeft: 5 }}
                                    className="field-group2"
                                  >
                                    <input
                                      id={inc._id}
                                      type="checkbox"
                                      name={inc?.name}
                                      value={inc._id}
                                      // onChange={handleCheckbox}
                                      checked={other?.includes(inc._id)}
                                      onChange={(e) => {
                                        if (e.target.checked) {
                                          setPage(1);
                                          setOther([...other, e.target.value]);
                                        } else {
                                          const filterVal = other.filter(
                                            (val, i) => val !== e.target.value
                                          );
                                          setOther(filterVal);
                                        }
                                      }}
                                    />
                                    <label
                                      htmlFor={inc._id}
                                      className="advanced-content-label"
                                    >
                                      {inc?.name}
                                    </label>
                                  </div>
                                );
                              })} */}
                                {/* <div
                              style={{ marginLeft: 5 }}
                              className="field-group2"
                            >
                              <input
                                id="furniture"
                                type="checkbox"
                                name="Furniture"
                                onChange={handleCheckbox}
                              />
                              <label
                                htmlFor="furniture"
                                className="advanced-content-label"
                              >
                                With furniture
                              </label>
                            </div>
                            <div
                              style={{ marginLeft: 5 }}
                              className="field-group2"
                            >
                              <input
                                id="2"
                                type="checkbox"
                                name="Elevator"
                                onChange={handleCheckbox}
                              />
                              <label
                                htmlFor="2"
                                className="advanced-content-label"
                              >
                                By elevator
                              </label>
                            </div>
                            <div
                              style={{ marginLeft: 5 }}
                              className="field-group2"
                            >
                              <input
                                id="3"
                                type="checkbox"
                                name="Garage"
                                onChange={handleCheckbox}
                              />
                              <label
                                htmlFor="3"
                                className="advanced-content-label"
                              >
                                With garage
                              </label>
                            </div>
                            <div
                              style={{ marginLeft: 5 }}
                              className="field-group2"
                            >
                              <input
                                id="4"
                                type="checkbox"
                                name="privateEntrance"
                                onChange={handleCheckbox}
                              />
                              <label
                                htmlFor="4"
                                className="advanced-content-label"
                              >
                                With private entrance
                              </label>
                            </div>
                            <div
                              style={{ marginLeft: 5 }}
                              className="field-group2"
                            >
                              <input
                                id="5"
                                type="checkbox"
                                name="storage"
                                onChange={handleCheckbox}
                              />
                              <label
                                htmlFor="5"
                                className="advanced-content-label"
                              >
                                With storage
                              </label>
                            </div>
                            <div
                              style={{ marginLeft: 5 }}
                              className="field-group2"
                            >
                              <input
                                id="6"
                                type="checkbox"
                                name="bathroomBath"
                                onChange={handleCheckbox}
                              />
                              <label
                                htmlFor="6"
                                className="advanced-content-label"
                              >
                                With shower
                              </label>
                            </div>
                            <div
                              style={{ marginLeft: 5 }}
                              className="field-group2"
                            >
                              <input
                                id="7"
                                type="checkbox"
                                name="Pets"
                                onChange={handleCheckbox}
                              />
                              <label
                                htmlFor="7"
                                className="advanced-content-label"
                              >
                                Pets allowed
                              </label>
                            </div>
                            <div
                              style={{ marginLeft: 5 }}
                              className="field-group2"
                            >
                              <input
                                id="8"
                                type="checkbox"
                                name="withCharging"
                                onChange={handleCheckbox}
                              />
                              <label
                                htmlFor="8"
                                className="advanced-content-label"
                              >
                                With charging station for electric cars
                              </label>
                            </div>
                            <div
                              style={{ marginLeft: 5 }}
                              className="field-group2"
                            >
                              <input
                                id="9"
                                type="checkbox"
                                name="laundryFacilitiesInTheBasement"
                                onChange={handleCheckbox}
                              />
                              <label
                                htmlFor="9"
                                className="advanced-content-label"
                              >
                                With laundry facilities
                              </label>
                            </div>
                            <div
                              style={{ marginLeft: 5 }}
                              className="field-group2"
                            >
                              <input
                                id="10"
                                type="checkbox"
                                name="withWheelchair"
                                onChange={handleCheckbox}
                              />
                              <label
                                htmlFor="10"
                                className="advanced-content-label"
                              >
                                With wheelchair access
                              </label>
                            </div>
                            <div
                              style={{ marginLeft: 5 }}
                              className="field-group2"
                            >
                              <input
                                id="11"
                                type="checkbox"
                                name="withBalcony"
                                onChange={handleCheckbox}
                              />
                              <label
                                htmlFor="11"
                                className="advanced-content-label"
                              >
                                With balcony
                              </label>
                            </div> */}
                              </div>
                            )}
                          </div>

                          {/* <div className="d-flex set-reset-space pt-4">
                       
                        <div className="apply-btn">
                          <button onClick={onApplyFilter}>
                            <BsCheck2
                              className="set-gap-app"
                              style={{ fontWeight: "bold" }}
                            />

                            {frontLabelsName
                              ? frontLabelsName.filter((e) => e.key == "lbl_apply")
                                  .length > 0
                                ? frontLabelsName.filter(
                                    (e) => e.key == "lbl_apply"
                                  )[0]["value"] || "lbl_apply"
                                : "lbl_apply"
                              : "lbl_apply"}
                          </button>
                        </div>
                      </div> */}
                        </div>
                      )}
                    </div>
                  </div>
                </PerfectScrollbar>
              </div>
              <div
                className="verticalLine3"
                style={{ marginTop: "32px" }}
              ></div>
            </div>
          ) : (
            <div
              className={`${allData ? "leftbar-fiter1" : "leftbar-fiter2"}`}
              style={{ borderRight: "none" }}
            >
              <div className="btn-filter">
                <button className="hide-btn" onClick={handleHideButton}>
                  <span>
                    <FaEye className="sets-gap-btn" />

                    {frontLabelsName
                      ? frontLabelsName.filter(
                          (e) => e.key == "lbl_show_filter",
                        ).length > 0
                        ? frontLabelsName.filter(
                            (e) => e.key == "lbl_show_filter",
                          )[0]["value"] || "lbl_show_filter"
                        : "lbl_show_filter"
                      : "lbl_show_filter"}
                  </span>
                </button>
              </div>
            </div>
          )}
          {open ? (
            <div className="col-lg-9 col-md-12">
              <div style={{ marginTop: "8px" }}>
                <div className="px-3 ">
                  {allData && (
                    <CardContent
                      page={page}
                      setPage={setPage}
                      setAllProperty={setAllProperty}
                      changePage={handlePageChange}
                      propertyData={propertyData}
                      // properties={properties}
                      properties1={allProperty}
                      propertyLoad={propertyLoad}
                      propertyTotal={propertyTotal}
                      filterLoading={filterLoading}
                      room={room}
                      search={search}
                      filterText={filterText}
                      rentalPeriod={rentalPeriod}
                      propertyType={propertyType}
                      propSizeValMin={propSizeVal.min}
                      propSizeValMax={propSizeVal.max}
                      propPriceValMin={propPriceVal.min}
                      propPriceValMax={propPriceVal.max}
                      // newToday ? "1" : newThisWeek ? "2" : ""={}
                      newToday={newToday}
                      newThisWeek={newThisWeek}
                      navType={navType}
                      gender={gender}
                      pets={pets}
                      inhabitants={inhabitants}
                      smoking={smoking}
                    />
                  )}
                </div>
                {tableOpen && (
                  <div className="tableStyle" style={{ marginTop: "32px" }}>
                    <TableData />
                  </div>
                )}
              </div>
            </div>
          ) : (
            <div className="col-lg-12 col-md-12 " style={{ width: "100%" }}>
              <div>
                {allData && (
                  <div style={{ marginTop: "10px" }}>
                    <CardContent
                      allData={allData}
                      page={page}
                      setPage={setPage}
                      setAllProperty={setAllProperty}
                      propertyData={propertyData}
                      // changePage={handlePageChange}
                      // properties={properties}
                      properties1={allProperty}
                      propertyTotal={propertyTotal}
                      propertyLoad={propertyLoad}
                      filterLoading={filterLoading}
                    />
                  </div>
                )}
                {tableOpen && (
                  <div className="tableStyle leftbar-fiter2">
                    <TableData />
                  </div>
                )}
              </div>
            </div>
          )}
        </div>
      </div>

      <Suspense fallback={<Loading />}>
        <Footer />
      </Suspense>
    </React.Fragment>
  );
}

const mapStateToProps = (state) => ({
  properties: state.properties,
  auth: state.auth,
  subscriptions: state.subscription,
  label: state.language,
});

export default connect(mapStateToProps, {
  getPropertyList,
  runningSubscription,
  dropdownPropertyField,
})(CardView);
